webpackJsonp([142629428675168],{

/***/ 394:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Jordan's Test Blog"}},"allMarkdownRemark":{"edges":[{"node":{"excerpt":"Far far away, behind the word mountains, far from the countries Vokalia and\nConsonantia, there live the blind texts. Separated they live in…","fields":{"slug":"/hi-folks/"},"frontmatter":{"date":"28 May, 2015","title":"Test Blog Post"}}},{"node":{"excerpt":"Wow! I love blogging so much already. Did you know that “despite its name, salted duck eggs can also be made from\nchicken eggs, though the…","fields":{"slug":"/my-second-post/"},"frontmatter":{"date":"06 May, 2015","title":"My Second Post!"}}},{"node":{"excerpt":"This is my first post on my new fake blog! How exciting! I’m sure I’ll write a lot more interesting things in the future. Oh, and here’s a…","fields":{"slug":"/hello-world/"},"frontmatter":{"date":"01 May, 2015","title":"Hello World"}}}]}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---index-26a060cea1532c95fca4.js